module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositEighteenMonthsCustomErrorNotAllowedTitle',
        errorBody: 'contractsView-depositEighteenMonthsCustomErrorForWhom',
        contentBuilder: 'depositEighteenMonths_customErrorNotAllowed',
        backButtonLabel: 'contractsView-errorBackButtonLabelGlobal',
        backButtonLink: '/myprofile/global'
    }
}
